var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "index-page" },
    [
      _c(
        "header",
        {
          staticClass: "header d-flex align-items-center fixed-top",
          attrs: { id: "header" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "container-fluid position-relative d-flex align-items-center justify-content-between",
            },
            [
              _vm._m(0),
              _c("nav", { staticClass: "navmenu", attrs: { id: "navmenu" } }, [
                _c("a", { attrs: { href: "/index.html" } }, [
                  _c("img", {
                    staticClass: "mobile-nav-toggle",
                    staticStyle: { display: "block !important" },
                    attrs: {
                      src: _vm.pngIcon,
                      alt: "Menu icon",
                      width: "48",
                      height: "48",
                    },
                  }),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _c("main", { staticClass: "main" }, [
        _c("section", { staticClass: "hero section", attrs: { id: "hero" } }, [
          _c("img", {
            attrs: {
              src: require("@/assets/login/assets/img/hero-bg.jpg"),
              alt: "",
              "data-aos": "fade-in",
            },
          }),
          _c(
            "div",
            {
              staticClass: "container text-center",
              attrs: { "data-aos": "fade-up", "data-aos-delay": "100" },
            },
            [
              _c("div", { staticClass: "row justify-content-center" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-8" },
                  [
                    _c("h2", [_vm._v("Welcome to 3GTAPP")]),
                    _c("p", { staticStyle: {} }, [
                      _c("span", {
                        attrs: { id: "main-title" },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.isMobile
                              ? "您的最佳<br>顧客體驗管理系統"
                              : "您的最佳顧客體驗管理系統"
                          ),
                        },
                      }),
                    ]),
                    _c(
                      "el-form",
                      {
                        ref: "loginForm",
                        staticClass: "input-form",
                        attrs: {
                          model: _vm.loginForm,
                          rules: _vm.loginRules,
                          autocomplete: "on",
                          "label-position": "left",
                        },
                        nativeOn: {
                          submit: function ($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _c("el-form-item", { attrs: { prop: "username" } }, [
                          _c(
                            "div",
                            { staticClass: "input-group" },
                            [
                              _c("span", { staticClass: "input-icon" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/login/assets/img/user.png"),
                                    alt: "user icon",
                                  },
                                }),
                              ]),
                              _c("el-input", {
                                ref: "username",
                                staticClass: "input-field",
                                attrs: {
                                  placeholder: "請輸入帳號",
                                  name: "username",
                                  type: "text",
                                  tabindex: "1",
                                  autocomplete: "on",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.filterAlphanumeric("username")
                                  },
                                },
                                model: {
                                  value: _vm.loginForm.username,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.loginForm, "username", $$v)
                                  },
                                  expression: "loginForm.username",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "Caps lock is On",
                              placement: "right",
                              manual: "",
                            },
                            model: {
                              value: _vm.capsTooltip,
                              callback: function ($$v) {
                                _vm.capsTooltip = $$v
                              },
                              expression: "capsTooltip",
                            },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { prop: "password" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "input-group" },
                                  [
                                    _c("span", { staticClass: "input-icon" }, [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/login/assets/img/lock.png"),
                                          alt: "lock icon",
                                        },
                                      }),
                                    ]),
                                    _c("el-input", {
                                      key: _vm.passwordType,
                                      ref: "password",
                                      staticClass: "input-field",
                                      attrs: {
                                        type: _vm.passwordType,
                                        placeholder: "請輸入密碼",
                                        name: "password",
                                        tabindex: "2",
                                        autocomplete: "off",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.filterAlphanumeric(
                                            "password"
                                          )
                                        },
                                        blur: function ($event) {
                                          _vm.capsTooltip = false
                                        },
                                      },
                                      nativeOn: {
                                        keyup: [
                                          function ($event) {
                                            return _vm.checkCapslock($event)
                                          },
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.handleLogin($event)
                                          },
                                        ],
                                      },
                                      model: {
                                        value: _vm.loginForm.password,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.loginForm,
                                            "password",
                                            $$v
                                          )
                                        },
                                        expression: "loginForm.password",
                                      },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "toggle-password",
                                        on: { click: _vm.showPwd },
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src:
                                              _vm.passwordType === "password"
                                                ? require("@/assets/login/assets/img/hidden.png")
                                                : require("@/assets/login/assets/img/eye.png"),
                                            alt: "toggle password",
                                          },
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-get-started",
                            attrs: {
                              loading: _vm.loading,
                              type: "primary",
                              size: "large",
                            },
                            nativeOn: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.handleLogin($event)
                              },
                            },
                          },
                          [_vm._v(" 登入 ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "line-height": "24px",
                          "max-height": "150px",
                          overflow: "auto",
                        },
                      },
                      [
                        _vm._l(_vm.noticeList, function (item, index) {
                          return [
                            _c("div", {
                              staticStyle: {
                                "line-height": "20px",
                                "font-size": "16px",
                                margin: "5px 0px",
                                color: "red",
                              },
                              domProps: { innerHTML: _vm._s(item) },
                            }),
                          ]
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _vm._m(1),
        ]),
      ]),
      _vm._m(2),
      _c("div", { attrs: { id: "preloader" } }),
      _c(
        "el-dialog",
        {
          attrs: { title: "Or connect with", visible: _vm.showDialog },
          on: {
            "update:visible": function ($event) {
              _vm.showDialog = $event
            },
          },
        },
        [
          _vm._v(
            " Can not be simulated on local, so please combine you own business simulation! ! ! "
          ),
          _c("br"),
          _c("br"),
          _c("br"),
          _c("social-sign"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "logo d-flex align-items-center",
        attrs: { href: "index.html" },
      },
      [_c("h1", { staticClass: "sitename" }, [_vm._v("3GTAPP")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "fixed-bottom-company-link",
        attrs: { href: "https://www.itainctw.com/", target: "_blank" },
      },
      [
        _c(
          "div",
          {
            staticClass: "fixed-bottom-company",
            staticStyle: { color: "rgb(0, 103, 187)" },
          },
          [_vm._v(" 2025©智遊旅程股份有限公司 ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass:
          "scroll-top d-flex align-items-center justify-content-center",
        attrs: { href: "#", id: "scroll-top" },
      },
      [_c("i", { staticClass: "bi bi-arrow-up-short" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }